import {api} from '~/shared/services/bffService';
import store from '~/shared/store';
import {selectCurrentAddress, selectIsUserLoggedIn} from '~/shared/store/selectors';
import {is401Error} from '~/shared/services/apiErrorService';

import {makeThunkAsyncActionCreator, makeActionCreator} from '../../redux-toolbelt';

import {MarketingBannerData} from './marketingBannersReducer';

export const getMarketingBanners = makeThunkAsyncActionCreator<never, MarketingBannerData>(
  'getMarketingBanners',
  async () => {
    const state = store.getState();
    const currentAddress = selectCurrentAddress(state);
    const isUserLoggedIn = selectIsUserLoggedIn(state);

    try {
      const result = await api.fetchMarketingBanners({
        longitude: currentAddress?.longitude,
        latitude: currentAddress?.latitude,
        cityId: currentAddress?.cityId,
      });

      if (result?.marketingBanners) {
        return {
          banners: result.marketingBanners,
          lastFetchedAddressKey: `${isUserLoggedIn}-${currentAddress?.addressKey}`,
        };
      }

      return {
        banners: [],
        lastFetchedAddressKey: `${isUserLoggedIn}-${currentAddress?.addressKey}`,
      };
    } catch (error: any) {
      // on 401 the error object should be passed forward, the 401 handling taking place outside the thunk
      if (is401Error(error)) {
        throw error;
      }
      if (error?.message) {
        throw new Error(error.message);
      }
      throw new Error('failed to run getMarketingBanners');
    }
  },
);

export const clearMarketingBanners = makeActionCreator<'clearMarketingBanners', never>('clearMarketingBanners');
